import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Button, Heading, Notice, Separator, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';

interface StartingCompanySubmittedModalContentProps {
  error: boolean;
  onCloseHandler: () => void;
}

const StartingCompanySubmittedModalContent: React.FC<StartingCompanySubmittedModalContentProps> = ({ error, onCloseHandler }) => {
  const translate = React.useContext(TranslationsContext).translate;
  return error ? (
    <Text className="text-center">
      <Notice isCloseButtonHidden={true} direction="vertical" align="center" type="error">
        <Heading id="modal-heading" element="h1" className="h3">
          {translate('starting-company.modal.fail')}
        </Heading>
        <Separator color="invisible" spacing="xsmall" />
        <p>{translate('starting-company.modal.try-again')}</p>
        <Separator color="invisible" spacing="xsmall" />
        <AnalyticsTrigger trigger={{ id: 'Click - Sulgen', callback: 'onClick' }}>
          <Button text={translate('starting-company.modal.close')} variant="secondary" onClick={() => onCloseHandler()} />
        </AnalyticsTrigger>
      </Notice>
    </Text>
  ) : (
    <Text className="text-center">
      <Notice isCloseButtonHidden={true} direction="vertical" align="center" type="success">
        <Heading id="modal-heading" element="h1" className="h3">
          {translate('starting-company.modal.thanks')}
        </Heading>
        <Separator color="invisible" spacing="xsmall" />
        <p>{translate('starting-company.modal.callback')}</p>
        <Separator color="invisible" spacing="xsmall" />
        <AnalyticsTrigger trigger={{ id: 'Click - Sulgen', callback: 'onClick' }}>
          <Button text={translate('starting-company.modal.close')} variant="secondary" onClick={() => onCloseHandler()} />
        </AnalyticsTrigger>
      </Notice>
    </Text>
  );
};

export default observer(StartingCompanySubmittedModalContent);
